import React from 'react';
import { useRouter } from 'next/router';
import useDstClickHandlers from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/useDstClickHandlers';
import useTopology from '@api/hooks/topology/useTopology';
import { DST_STATES } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/utils';
import Result from './Dst/Result';
import Attempted from './Dst/Attempted';
import Unattempted from './Dst/Unattempted';

const getDstComponent = (dstState) => {
  switch (dstState) {
    case DST_STATES.UNATTEMPTED:
      return Unattempted;
    case DST_STATES.RESUME:
    case DST_STATES.ATTEMPTED:
      return Attempted;
    case DST_STATES.REATTEMPT:
    case DST_STATES.WON:
      return Result;
    default:
      return null;
  }
};

const Scholarship = ({ block }) => {
  const { data } = block || { data: [] };
  const dstState = data?.[0]?.state;
  const {
    query: { goalSlug, goalUID }
  } = useRouter();
  const { topology: goalData } = useTopology(goalUID);
  const { name: goalName } = goalData;

  const clickHandlers = useDstClickHandlers({
    goalUID,
    goalSlug,
    goalName,
    lps: 'Home'
  });

  const Component = getDstComponent(dstState);
  if (Component)
    return <Component block={block} clickHandlers={clickHandlers} />;

  return null;
};

export default Scholarship;
